import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tab, Grid, Box, Paper, Typography, CircularProgress } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { eliminarCodigoQR, generarCodigoQR, generarOperacionCancelacion, getEstadoOperacionCancelaciones, getOperacion, obtenerCalculoTasaRR, obtenerEstadoOperacionQr, obtenerVerificacionPagoQr } from 'app/features/Profesionales/profesionalesAPI';
import { clearCodigoQr, setCodigoQr, setEstaEnVistaQr } from 'app/features/CodigoQr/codigoQrSlice';
import { DetalleMontoTasa } from 'components/reinscripcionRehabilitacion/DetalleMontoTasa';
import Swal from 'sweetalert2'

export const PagoQR = ({setMedioDePago, setResult, tasaRR = null, setBanderaOperacion, banderaOperacion, limpiarNotificaciones = null, contadorNotificacion = null, debeGenerarNuevoQR = null,  setTieneDiferenciaEnPago = null, idEstado = null, setAcabaDePagar = null }) => {

  const [numeroOperacion, setNumeroOperacion] = useState(null);
  const [operacionQr, setOperacionQr] = useState(null);
  const [bloquearBtn, setBloquearBtn] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [notificacionPago, setNotificacionPago] = useState(false);
  const [countdown, setCountdown] = useState(300);
  const [ocultarQr, setOcultarQr] = useState(false);
  const [mostrarSpinner, setMostrarSpinner] = useState(false);

  const tipoTramite = Number(localStorage.tpoTramite);

  const dispatch = useDispatch();
  const { qr, tiempoVerificacion, vencimiento } = useSelector(state => state.codigoQrReducer.codigoQr);

  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const crearCodigoQR = async () => {
    let nroOperacion = 0;

    if(tipoTramite !== 3 ){
      const { idOperacion } = await getOperacion();
      nroOperacion = idOperacion;
    } else {
      const listaOperaciones = await getEstadoOperacionCancelaciones();
      
      listaOperaciones.$values.map((op) => {
          if(op.estado === 0 ) {
            nroOperacion = op.idOperacion;
          }
      })
    }


    setNumeroOperacion(nroOperacion);

    if (qr === null) {
      const resp = await generarCodigoQR(nroOperacion)
      if (resp) {
        dispatch(setCodigoQr(resp));

        // solo para RR
        if(tasaRR !== null) {
          limpiarNotificaciones();
          contadorNotificacion(5.5);
        }
      }
    } else {
      // QR ya generado desde ModalTyCCancelacion, solo notificar
      if(tasaRR !== null) {
        limpiarNotificaciones();
        contadorNotificacion(5.5);
      }
    }
  }

  const estadoOperacionQr = async () => {
    const data = await obtenerEstadoOperacionQr(numeroOperacion);
    setOperacionQr(data)
    if (data) {
      if (tasaRR !== null) {
        limpiarNotificaciones();

        if (localStorage.tpoTramite === "3"){
          setAcabaDePagar(true);
        }
        if(idEstado === 6 && localStorage.tpoTramite === "3"){
          setTieneDiferenciaEnPago(false);
        }
      }
      setResult(true)
    }
  }

  const verificacionPago = async () => {
    setNotificacionPago(false)
    setDisabledBtn(true)
    const data = await obtenerVerificacionPagoQr(numeroOperacion);
    if (data) {
      if (tasaRR !== null) {
        limpiarNotificaciones();

        if (localStorage.tpoTramite === "3"){
          setAcabaDePagar(true);
        }
        if(idEstado === 6 && localStorage.tpoTramite === "3"){
          setTieneDiferenciaEnPago(false);
        }
      }
      setResult(true)
    }
    setDisabledBtn(false);
    setNotificacionPago(true);
  }

  const goBack = async () => {
    setBloquearBtn(true);
    const data = await eliminarCodigoQR(numeroOperacion);
    setBloquearBtn(false);
    if (data) {
      if (tasaRR) {
        setBanderaOperacion(!banderaOperacion)
      }
      dispatch(clearCodigoQr());
      dispatch(setEstaEnVistaQr());
      setMedioDePago("0")
    }
  }

  const generarNuevoQr = async() => {
    try{
      // setBloquearBtn(true);
      setMostrarSpinner(true);
      setDisabledBtn(true);
      limpiarNotificaciones();
      contadorNotificacion(5.5);
      const data = await eliminarCodigoQR(numeroOperacion);
      setBloquearBtn(false);
      if (data) {
        // Obtener calculo de tasaRR genera una operacion en nestado 0
        await obtenerCalculoTasaRR(localStorage.idLegajo);
        let nroOperacion = 0;

        if(tipoTramite !== 3 ){
          const {idOperacion} = await getOperacion();
          nroOperacion = idOperacion;
        } else {
          const idOperacion = await generarOperacionCancelacion(localStorage.idLegajo, tasaRR.fecha.replace(/\//g, "-"), tasaRR.montoTramite, tasaRR.conceptos.$values);
          nroOperacion = idOperacion;
        }

        setNumeroOperacion(nroOperacion);
        
        const resp = await generarCodigoQR(nroOperacion)
        if (resp) {
          dispatch(setCodigoQr(resp));
          limpiarNotificaciones();
          contadorNotificacion(5.5);
          setOcultarQr(false);
          setNotificacionPago(false);
        }
      }
      setMostrarSpinner(false); 
      setDisabledBtn(false);
    } catch (error) {
      setMostrarSpinner(false);
      setDisabledBtn(false);
      setBloquearBtn(false);
      // Manejo de error, por ejemplo:
      // Swal.fire('Error', 'Ocurrió un error al generar el QR', 'error');
    }
  }

  const formatCountdown = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const expirarQr = () => {
    if (tasaRR !== null){
    setOcultarQr(true);
    }
  }

  useEffect(() => {
    crearCodigoQR()
  }, [])

 
  // Countdown y expiración QR
  useEffect(() => {
    if (numeroOperacion !== null && qr !== null) {
      // setear 300 segundos que son 5 min
      setCountdown(300);

      let countdownInterval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            expirarQr();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearInterval(countdownInterval);
      };
    }
  }, [tiempoVerificacion, numeroOperacion, qr]);

  // Estado de operación QR polling
  useEffect(() => {
    if (numeroOperacion !== null && qr !== null) {
      const intervalId = setInterval(() => {
        estadoOperacionQr();
      }, 5000);

      // Timeout para mostrar notificación si no hay operación
      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
        if (!operacionQr) {
          setNotificacionPago(true);
        }
      }, tiempoVerificacion * 1000);

      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }
  }, [tiempoVerificacion, numeroOperacion, qr, operacionQr]);

  useEffect(() => {
    dispatch(setEstaEnVistaQr());
  }, [])

  useEffect(() => {
    if(debeGenerarNuevoQR) {
      generarNuevoQr()
    }
  }, [debeGenerarNuevoQR])

  return (
    <Grid container>
       {/* <Typography mb={'2rem'} style={{ fontSize: 14 }} >
          * <b>Cambiará el Qr en caso de que se haya quedado sin tiempo y seleccionado continuar en la sesión.</b> 
        </Typography> */}
        <Box display="flex" flexDirection={tasaRR !== null ? (isXsScreen ? "column" : "") : "column" } alignItems={"center"} justifyContent={tasaRR !== null ? "" :"center"} width={'100%'}>
            <Grid item xs={isXsScreen ? 12 : 6}>
              { ocultarQr ? 
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                    <Typography gutterBottom display="flex" justifyContent="center" alignItems="center" variant="body2" fontWeight="bold" textAlign="center" mt={2}>
                      El QR generado se venció y ya no está <br/> disponible.<br/> Para continuar, puede generar uno nuevo.
                    </Typography>
                    <Button
                    variant="contained"
                    color="secondary"
                    disabled={disabledBtn || bloquearBtn}
                    onClick={generarNuevoQr}
                    sx={{ mb: 4, mt: 2 }}
                  >
                    <Box sx={{ minWidth: 170, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {mostrarSpinner ? (
                        <CircularProgress size={24} />
                      ) : (
                        <Typography variant='inherit'>
                          Generar nuevo QR
                        </Typography>
                      )}
                    </Box>
                  </Button>
                </Box>
                :
                <Box>
                  <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" fontSize={'0.85rem'}>
                      <b>Numero de operación: {numeroOperacion}</b>
                  </Typography>
  
                 <Box display="flex" justifyContent="center" alignItems="center">
                    {
                      (qr === null) ? <CircularProgress /> : <img src={"data:image/png;base64," + qr} style={{width: '150px', height:'150px' }} />    
                    } 
                  </Box>
                  {(qr !== null) &&
                    <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" fontSize={'0.85rem'}>
                      
                        <b>Vencimiento: </b>{vencimiento}
                    </Typography>
                  }
                   {(qr !== null && tasaRR !== null) && (
                      <Box>
                        <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" variant="body2" fontWeight="bold" fontSize="0.9rem">
                          Tiempo restante del QR: <b style={{color: 'red', marginLeft: '0.5em'}}> {formatCountdown(countdown)} </b>
                        </Typography>
  
                        <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" variant="body2" fontWeight="bold" textAlign={'center'}>
                          (Pasado este tiempo,{isXsScreen && <br/>}  se generará un nuevo QR) 
                        </Typography>
                      </Box>
                    )}
                </Box>
              }
              {
                (qr !== null) && (
                <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={3}>
                  { !notificacionPago ? <CircularProgress /> : <CloseIcon color='error' fontSize='large'/> }
                
                    <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" fontSize={'0.85rem'} ml={2} mt={1} >
                      { !notificacionPago ? "Esperando notificacion de pago" : "No se recibió notificación de pago" } 
                    </Typography>
                </Box>
                )
              }

              <Typography gutterBottom display='flex' justifyContent="center" alignItems="center" fontSize={'0.85rem'} mt={2} width={'60%'}textAlign={'center'}margin={'auto'}>
                <b>Si ya efectuó el pago y aún no visualiza la imputacion del mismo, presione "Verificar Pago"</b>
              </Typography>

              
              <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                <Button variant="contained" color="secondary" disabled={ disabledBtn || bloquearBtn } onClick={verificacionPago}>
                  Verificar Pago
                </Button>
              </Box>
            </Grid>

        {tasaRR !== null && (
          isXsScreen ? (
            <Grid item xs={12} mt={4}>
              <DetalleMontoTasa tasaRR={tasaRR} />
            </Grid>
          ) : (
            <Grid item xs={5}>
              <DetalleMontoTasa tasaRR={tasaRR} />
            </Grid>
          )
        )}
      </Box>

          <Grid item xs={12} display='flex' mt={4} >
            <Grid xs={12} md={6} display={isXsScreen ? 'flex' : ''} justifyContent={isXsScreen ? "center" : ""}>
              <Button startIcon={<ArrowBackIosIcon />} onClick={() => goBack()} variant="contained" color="error"  fullWidth={isXsScreen} disabled={ disabledBtn || bloquearBtn  } >
                { bloquearBtn ? <CircularProgress /> : "Atras" } 
              </Button>
            </Grid>
          </Grid>
    </Grid>
  )
}
